import React from 'react'

const LanguageItem = ({ item: { name, value, level } }) => {
    const levelStyle = {
        fontSize: 'smaller',
        float: 'right',
        color: '#909090'
    }
    return (
        <li className="border-line-h">
            <div className="name"><span>{name}</span> <span style={levelStyle}>{level}</span></div>
            <div className="progress">
                <div className="percentage" style={{ width: `${value}%` }}></div>
            </div>
        </li>
    )
}

export default LanguageItem